

//Save  Picture function: this.$emit('photoTaken', { image: this.img, close: true });
//close  this.$emit('close_camera_component_dialog');
export default {
  name: "CameraWrapper",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    displayPopup: {
      type: Boolean,
      default: true,
    },
    resolution: {
      type: Object,
      default: () => { return { height: 375, width: 500 } },
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CameraItem: require('./cameraItem.vue').default,
  },
  data: function () {
    return {
    };
  },
  computed: {
 
  },
  watch: {

  },
  methods: {
    photoTaken(payload) {
      this.$emit('photoTaken', payload);
    },
    closeCamera() {
      this.$emit('close_camera_component_dialog');
    }
  }
};
